import React from "react";
import { Col, Button, Modal, Image, Row } from "react-bootstrap";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import DatePicker from "react-datepicker";
import CommonDropdown from "./../../../components/commonDropdown";
import InputField from "./../../../components/InputFieldComponent";

export const NewOfferForm = ({
  isOpen,
  onHide,
  nextButton,
  startDate,
  DOB,
  onSelectStartTime,
  startTime,
  lessonRate,
  timeStatus,
  time,
  location,
  lessonDuration,
  LessonFrequency,
  onChange,
  onSelect,
}) => {
  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal NewOfferFormModal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 15px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h3>Send Mawuli a special offer for Maths (GCSE)</h3>
              <div className="modal-para" style={{ marginBottom: "15px" }}>
                Mawuli will have 24 hours to secure lesson.
              </div>
              <div className="flex" style={{ flexDirection: "column" }}>
                <div className="flex" style={{ flexWrap: "wrap" }}>
                  <div style={{ flex: 1 }}>
                    <div
                      className="input-field-style"
                      style={{ marginBottom: "11px" }}
                    >
                      Start Date
                    </div>
                    <DatePicker
                      selected={DOB}
                      placeholderText="Start date"
                      onChange={(date) => onSelect(date.getTime(), "startDate")}
                      dateFormat="dd/MM/yyyy"
                      showYearDropdown
                      selected={startDate}
                    />
                  </div>

                  <div style={{ flex: 1 }} className="mid-div">
                    <CommonDropdown
                      dropdownTitle="Start time"
                      value={{ name: time }}
                      itemArray={[
                        { name: "12:00" },
                        { name: "12:30" },
                        { name: "1:00" },
                        { name: "1:30" },
                        { name: "2:00" },
                        { name: "2:30" },
                        { name: "3:00" },
                        { name: "3:30" },
                        { name: "4:00" },
                        { name: "4:30" },
                        { name: "5:00" },
                        { name: "5:30" },
                        { name: "6:00" },
                        { name: "6:30" },
                        { name: "7:00" },
                        { name: "7:30" },
                        { name: "8:00" },
                        { name: "8:30" },
                        { name: "9:00" },
                        { name: "9:30" },
                        { name: "10:00" },
                        { name: "10:30" },
                        { name: "11:00" },
                        { name: "11:30" },
                      ]}
                      style={{
                        height: "45px",
                        fontSize: "14px",
                        color: "#0f0f0f",
                        arrowIconSize: "12px",
                        headTitleStyle: {
                          fontWeight: "normal",
                          fontSize: "14px",
                          color: "#0f0f0f",
                          marginBottom: "8px",
                          fontFamily: "CircularStdMedium, Arial, sans-serif",
                        },
                        dropdownParentStyle: {
                          padding:"0px 20px",
                          borderRadius: "5px",
                          
                        },
                        // borderGroup:
                        //   !firstName && firstNameReq ? "1px solid #fa4a4a" : null,
                        // backgroundColor: !firstName && firstNameReq ? "#fff1f1" : null,
                      }}
                      onSelect={(value) => onSelect(value.name, "time")}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <CommonDropdown
                      value={{ name: timeStatus }}
                      itemArray={[{ name: "PM" }, { name: "AM" }]}
                      style={{
                        height: "45px",
                        fontSize: "14px",
                        color: "#0f0f0f",
                        arrowIconSize: "12px",
                        headTitleStyle: {
                          fontWeight: "normal",
                          fontSize: "14px",
                          color: "#0f0f0f",
                          marginBottom: "29px",
                          fontFamily: "CircularStdMedium, Arial, sans-serif",
                        },
                        dropdownParentStyle: {
                          padding:"0px 20px",
                          borderRadius: "5px",
                        },
                        // borderGroup:
                        //   !firstName && firstNameReq ? "1px solid #fa4a4a" : null,
                        // backgroundColor: !firstName && firstNameReq ? "#fff1f1" : null,
                      }}
                      onSelect={(value) => onSelect(value.name, "timeStatus")}
                    />
                  </div>
                </div>
                <CommonDropdown
                  dropdownTitle="Location"
                  value={{ name: location }}
                  itemArray={[
                    { name: "Online" },
                    { name: "In-person (Student's address)" },
                    { name: "In-Person (Tutor's address)" },
                    { name: "In-Person (Other address)" },
                  ]}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                    color: "#0f0f0f",
                    arrowIconSize: "12px",
                    headTitleStyle: {
                      fontWeight: "normal",
                      fontSize: "14px",
                      color: "#0f0f0f",
                      marginBottom: "8px",
                      fontFamily: "CircularStdMedium, Arial, sans-serif",
                    },
                    dropdownParentStyle: {
                      padding:"0px 20px",
                      borderRadius: "5px",
                    },
                    // borderGroup:
                    //   !firstName && firstNameReq ? "1px solid #fa4a4a" : null,
                    // backgroundColor: !firstName && firstNameReq ? "#fff1f1" : null,
                  }}
                  onSelect={(value) => onSelect(value.name, "location")}
                />
                {location && !(location === "Online") ? (
                  <div>
                    <InputField
                      InputHeadTitle="Post code"
                      placeholder="Post code"
                      style={{
                        height: "45px",
                        headTitle: {
                          fontSize: "14px",
                          marginBottom: "15px",
                          fontWeight: "normal",
                          fontFamily: "CircularStdMedium, Arial, sans-serif",
                        },
                        border: "none",
                      }}
                      value={"L1 6BU"}
                      disabled={true}
                      image={require("./../../../assets/icons/lock.png")}
                    />
                    <div
                      className="common-para"
                      style={{
                        color: "#707070",
                        fontSize: "12px",
                        marginBottom: "10px",
                      }}
                    >
                      Students full address will be provided ones they have
                      accepted your revised lesson
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <CommonDropdown
                  dropdownTitle="Lesson duration"
                  value={{ name: lessonDuration }}
                  itemArray={[
                    { name: "0:30" },
                    { name: "0:45" },
                    { name: "1:00" },
                    { name: "1:15" },
                    { name: "1:30" },
                    { name: "1:45" },
                    { name: "2:00" },
                    { name: "2:15" },
                    { name: "2:30" },
                    { name: "2:45" },
                    { name: "3:00" },
                  ]}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                    color: "#0f0f0f",
                    arrowIconSize: "12px",
                    headTitleStyle: {
                      fontWeight: "normal",
                      fontSize: "14px",
                      color: "#0f0f0f",
                      marginBottom: "8px",
                      fontFamily: "CircularStdMedium, Arial, sans-serif",
                    },
                    dropdownParentStyle: {
                      padding:"0px 20px",
                      borderRadius: "5px",
                    },
                    // borderGroup:
                    //   !firstName && firstNameReq ? "1px solid #fa4a4a" : null,
                    // backgroundColor: !firstName && firstNameReq ? "#fff1f1" : null,
                  }}
                  onSelect={(value) => onSelect(value.name, "lessonDuration")}
                />
                <CommonDropdown
                  dropdownTitle="Lesson frequency"
                  value={{ name: LessonFrequency }}
                  itemArray={[
                    { name: "Every week" },
                    { name: "Every fornight" },
                    { name: "One-off lesson" },
                  ]}
                  style={{
                    height: "45px",
                    fontSize: "14px",
                    color: "#0f0f0f",
                    arrowIconSize: "12px",
                    headTitleStyle: {
                      fontWeight: "normal",
                      fontSize: "14px",
                      color: "#0f0f0f",
                      marginBottom: "8px",
                      fontFamily: "CircularStdMedium, Arial, sans-serif",
                    },
                    dropdownParentStyle: {
                      padding:"0px 20px",
                      borderRadius: "5px",
                    },
                    // borderGroup:
                    //   !firstName && firstNameReq ? "1px solid #fa4a4a" : null,
                    // backgroundColor: !firstName && firstNameReq ? "#fff1f1" : null,
                  }}
                  onSelect={(value) => onSelect(value.name, "LessonFrequency")}
                />
                <InputField
                  InputHeadTitle="Lesson rate"
                  placeholder="lesson fee"
                  style={{
                    height: "45px",
                    headTitle: {
                      fontSize: "14px",
                      marginBottom: "15px",
                      fontWeight: "normal",
                      fontFamily: "CircularStdMedium, Arial, sans-serif",
                    },
                    border: "none",
                  }}
                  value={lessonRate}
                  onChange={onChange}
                  preText={"GBP"}
                />
              </div>{" "}
              <div
                className="common-para"
                style={{ color: "#707070", fontSize: "12px" }}
              >
                Enter the rate you would like to request for this lesson. This
                wont't include service fee or applicable taxes.
              </div>
              <div
                className="flex-between-center"
                style={{ marginTop: "30px" }}
              >
                <div
                  className="green-txt flex-center"
                  onClick={onHide}
                  style={{
                    width: "16px",
                    paddingBottom: "2px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                  }}
                >
                  <Image
                    src={require("./../../../assets/icons/back-left.png")}
                    style={{
                      width: "14px",
                    }}
                  />
                  Back
                </div>
                <Button
                  className="green-Button"
                  style={{
                    width: "162px",
                    height: "45px",
                    backgroundColor: "#2cb46d",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    color: "#ffffff",
                  }}
                  onClick={nextButton}
                >
                  Send special offer
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};
